var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"connector-kyc-layout"},[_c('v-main',[_vm._t("default")],2),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }